// src/components/AnalyticsPage.js
import React, { useState, useEffect } from "react";
import axios from "axios";
import { Table, Container } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { BACKEND_BASE } from "./constant";
import { useNavigate } from "react-router-dom";

const AnalyticsPage = () => {
  const [analyticsData, setAnalyticsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortConfig, setSortConfig] = useState({
    key: "timestamp",
    direction: "asc",
  });
  const navigate = useNavigate();

  useEffect(() => {
    const fetchAnalyticsData = async () => {
      try {
        const response = await axios.get(`${BACKEND_BASE}/analytics`);
        setAnalyticsData(response.data.reverse());
      } catch (error) {
        console.error("Error fetching analytics data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalyticsData();
  }, []);

  const sortedData = () => {
    let sortableData = [...analyticsData];
    if (sortConfig !== null) {
      sortableData.sort((a, b) => {
        if (a[sortConfig.key] < b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? -1 : 1;
        }
        if (a[sortConfig.key] > b[sortConfig.key]) {
          return sortConfig.direction === "asc" ? 1 : -1;
        }
        return 0;
      });
    }
    return sortableData;
  };

  const requestSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  const getClassNamesFor = (name) => {
    if (sortConfig.key === name) {
      return sortConfig.direction === "asc" ? "asc" : "desc";
    }
    return;
  };

    // Function to convert data to CSV format
const convertToCSV = (data) => {
  const headers = ["PID",	"Screen",	"Component",	"Action",	"DeviceType","Timestamp"];

  const csvRows = [];

  // Add headers row
  csvRows.push(headers.join(","));

  // Helper function to escape commas and quotes
  const escapeCSVValue = (value) => {
    if (typeof value === "string") {
      // Escape double quotes by replacing them with two double quotes
      value = value.replace(/"/g, '""');
      // If value contains a comma, wrap it in double quotes
      if (value.includes(",") || value.includes("\n")) {
        return `"${value}"`;
      }
    }
    return value;
  };

  // Add data rows
  data.forEach((item) => {
    const row = [
      escapeCSVValue(item.profileID || "N/A"), // PID
      escapeCSVValue(item.screenId || "N/A"), // Screen
      escapeCSVValue(item.component || "N/A"), // Component
      escapeCSVValue(item.action || "N/A"), // Action
      escapeCSVValue(item.deviceType || "N/A"), // deviceType      
      escapeCSVValue(new Date(item.timestamp).toLocaleString() || "N/A"), // Timestamp
    ];
    csvRows.push(row.join(","));
  });

  return csvRows.join("\n");
};


  // Function to handle CSV download
  const downloadCSV = () => {
    const csv = convertToCSV(analyticsData);
    const blob = new Blob([csv], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("hidden", "");
    a.setAttribute("href", url);
    a.setAttribute("download", "users_data.csv");
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };
  return (
    <Container>
      <h1 className="my-4">Analytics Data</h1>
      <Button
        className="sticky-back-button my-2"
        onClick={() => navigate("/")}
        style={{ backgroundColor: "rgb(72, 39, 110)" }}
      >
        Back
      </Button>
      <Button
        onClick={downloadCSV}
        className="sticky-back-button"
        style={{ marginLeft: "20px", backgroundColor: "rgb(72, 39, 110)" }}
      >
        Export to CSV
      </Button>
      <Button
        className="sticky-back-button my-2 mx-2"
        onClick={() => setAnalyticsData(sortedData())}
        style={{ backgroundColor: "rgb(72, 39, 110)" }}
      >
        Sort
      </Button>
      {loading ? (
        <p>Loading...</p>
      ) : (
        <Table responsive="sm" striped bordered hover>
          <thead>
            <tr>
              <th
                onClick={() => requestSort("profileID")}
                className={getClassNamesFor("profileID")}
              >
                PID
              </th>
              <th
                onClick={() => requestSort("screenId")}
                className={getClassNamesFor("screenId")}
              >
                Screen
              </th>
              <th
                onClick={() => requestSort("component")}
                className={getClassNamesFor("component")}
              >
                Component
              </th>
              <th
                onClick={() => requestSort("action")}
                className={getClassNamesFor("action")}
              >
                Action
              </th>
              <th
                onClick={() => requestSort("deviceType")}
                className={getClassNamesFor("deviceType")}
              >
                DeviceType
              </th>
              <th
                onClick={() => requestSort("timestamp")}
                className={getClassNamesFor("timestamp")}
              >
                Timestamp
              </th>
            </tr>
          </thead>
          <tbody>
            {analyticsData.map((event, index) => (
              <tr key={index}>
                <td>{event.profileID}</td>
                <td>{event.screenId}</td>
                <td>{event.component}</td>
                <td>{event.action}</td>
                <td>{event.deviceType}</td>
                <td>{new Date(event.timestamp).toLocaleString()}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </Container>
  );
};

export default AnalyticsPage;
